import httpService from "./httpService";
import utils from "./utils";

export default {
  save(form) {
    return httpService.post(`folderAccessory`, form);
  },
  saveLink(form) {
    return httpService.post(`folderAccessory/saveLink`, form);
  },
  findByFolderId(form) {
    let params = utils.merge(form);
    return httpService.get("folderAccessory/findByFolderId", {params});
  },
  findById(id) {
    return httpService.get("folderAccessory/findById/" + id);
  },
  delete(id) {
    return httpService.delete("folderAccessory/" + id);
  },
  findTreeFolder(form) {
    let params = utils.merge(form);
    return httpService.get("folderAccessory/findTreeFolder", {params});
  },
  update(form) {
    return httpService.put("folderAccessory", form);
  },
  findBreadCrumbs(form) {
    let params = utils.merge(form);
    return httpService.get("folderAccessory/findBreadCrumbs", {params});

  },
  findTreeFolderFolderAdmin(form) {
    let params = utils.merge(form);
    return httpService.get("folderAccessory/findTreeFolderFolderAdmin", {params});

  },
  search(form) {
    let params = utils.merge(form);
    return httpService.get("folderAccessory/search", {params});

  },

  disableEdit(folderId) {
    return httpService.put("folderAccessory/disableEdit/" + folderId);
  },
  enableEdit(folderId) {
    return httpService.put("folderAccessory/enableEdit/" + folderId);
  },
  scanFile(lstFolderAccessory) {
    return httpService.post("folderAccessory/scanFile", lstFolderAccessory);
  },
  moveAccessory(form) {
    return httpService.post(`folderAccessory/moveAccessory`, form);
  },
  copyAccessory(form) {
    return httpService.post(`folderAccessory/copyAccessory`, form);
  },
  findListFolderDest(form) {
    let params = utils.merge(form);
    return httpService.get("folderAccessory/findListFolderDest", {params});
  },
  findAllByIdIn(ids) {
    return httpService.get("folderAccessory/findAllByIdIn",
      {params: {ids: ids}}
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/folderAccessoryService.js